export const Methods = {
  Launch: 'launch',
  Run: 'run',
  Stop: 'stop',
  Confirm: 'confirm',
  UI: 'ui',
  UIRespond: 'ui.respond',
  Tokens: 'tokens',
  TokensHistory: 'tokens.history',
  Media: 'media',
  MediaGenerate: 'media.generate',
  MediaGenerateCancel: 'media.generate.cancel',
  MediaGenerateResume: 'media.generate.resume',
  MediaIndex: 'media.index',
  MediaSearch: 'media.search',
  MediaTags: 'media.tags',
  MediaTagsUpdate: 'media.tags.update',
  MediaMetaUpdate: 'media.meta.update',
  MediaActive: 'media.active',
  MediaHistory: 'media.history',
  MediaHistoryLatest: 'media.history.latest',
  MediaHistoryTop: 'media.history.top',
  MediaLookup: 'media.lookup',
  MediaMeta: 'media.meta',
  MediaImage: 'media.image',
  Scrapers: 'scrapers',
  MediaScrape: 'media.scrape',
  MediaScrapeStatus: 'media.scrape.status',
  MediaScrapeCancel: 'media.scrape.cancel',
  MediaScrapeResume: 'media.scrape.resume',
  MediaBrowse: 'media.browse',
  MediaBrowseIndex: 'media.browse.index',
  MediaControl: 'media.control',
  MediaActiveUpdate: 'media.active.update',
  MediaCleanOrphans: 'media.clean.orphans',
  MediaTitleParse: 'media.title.parse',
  Settings: 'settings',
  SettingsUpdate: 'settings.update',
  SettingsReload: 'settings.reload',
  SettingsLogsDownload: 'settings.logs.download',
  SettingsBackup: 'settings.backup',
  SettingsBackupList: 'settings.backup.list',
  SettingsBackupInspect: 'settings.backup.inspect',
  SettingsBackupDelete: 'settings.backup.delete',
  SettingsBackupRestore: 'settings.backup.restore',
  SettingsBackupStatus: 'settings.backup.status',
  SettingsBackupRemoteRun: 'settings.backup.remote.run',
  SettingsBackupRemoteList: 'settings.backup.remote.list',
  SettingsBackupRemoteRestore: 'settings.backup.remote.restore',
  PlaytimeLimits: 'settings.playtime.limits',
  PlaytimeLimitsUpdate: 'settings.playtime.limits.update',
  Playtime: 'playtime',
  Clients: 'clients',
  ClientsCurrent: 'clients.current',
  ClientsDelete: 'clients.delete',
  ClientsPairStart: 'clients.pair.start',
  ClientsPairCancel: 'clients.pair.cancel',
  Profiles: 'profiles',
  ProfilesNew: 'profiles.new',
  ProfilesUpdate: 'profiles.update',
  ProfilesDelete: 'profiles.delete',
  ProfilesActive: 'profiles.active',
  ProfilesSwitch: 'profiles.switch',
  ProfilesVerify: 'profiles.verify',
  Systems: 'systems',
  Launchers: 'launchers',
  LaunchersRefresh: 'launchers.refresh',
  Mappings: 'mappings',
  MappingsNew: 'mappings.new',
  MappingsDelete: 'mappings.delete',
  MappingsUpdate: 'mappings.update',
  MappingsReload: 'mappings.reload',
  Readers: 'readers',
  ReadersWrite: 'readers.write',
  ReadersWriteCancel: 'readers.write.cancel',
  Version: 'version',
  Health: 'health',
  Inbox: 'inbox',
  InboxDelete: 'inbox.delete',
  InboxClear: 'inbox.clear',
  SettingsAuthClaim: 'settings.auth.claim',
  SettingsAuthStatus: 'settings.auth.status',
  SettingsAuthUnlink: 'settings.auth.unlink',
  SettingsAuthLink: 'settings.auth.link',
  SettingsAuthLinkStatus: 'settings.auth.link.status',
  SettingsAuthLinkCancel: 'settings.auth.link.cancel',
  UpdateCheck: 'update.check',
  UpdateApply: 'update.apply',
  InputKeyboard: 'input.keyboard',
  InputGamepad: 'input.gamepad',
  Screenshot: 'screenshot',
} as const;

export type Method = (typeof Methods)[keyof typeof Methods];

export const Notifications = {
  ReadersAdded: 'readers.added',
  ReadersRemoved: 'readers.removed',
  Running: 'running',
  TokensAdded: 'tokens.added',
  TokensRemoved: 'tokens.removed',
  TokensStaged: 'tokens.staged',
  TokensStagedReady: 'tokens.staged.ready',
  MediaStarted: 'media.started',
  MediaStopped: 'media.stopped',
  MediaIndexing: 'media.indexing',
  MediaScraping: 'media.scraping',
  PlaytimeLimitReached: 'playtime.limit.reached',
  PlaytimeLimitWarning: 'playtime.limit.warning',
  InboxAdded: 'inbox.added',
  ClientsPaired: 'clients.paired',
  ProfilesActive: 'profiles.active',
  ProfilesData: 'profiles.data',
  UIChanged: 'ui.changed',
  AuthLinkStatus: 'auth.link.status',
  BackupState: 'backup.state',
} as const;

export type NotificationType = (typeof Notifications)[keyof typeof Notifications];

export const DeprecatedMethods = new Set<Method>([Methods.Launch, Methods.MediaIndex]);

export const UnboundedMethods = new Set<Method>([
  Methods.SettingsBackup,
  Methods.SettingsBackupRestore,
  Methods.SettingsBackupRemoteRun,
  Methods.SettingsBackupRemoteRestore,
]);
